<!-- <div class="card-graph"    id="gauge{{pageTab}}{{index}}" ></div> -->
<div id="gauge{{pageTab}}{{index}}" *ngIf="data">
    <ngx-charts-gauge [view]="view" [scheme]="{domain:selectedColorArray}" [tooltipDisabled]="true" [results]="data" [min]="0" [max]="4"
     [showAxis]="false" [angleSpan]="220" [startAngle]="-110">
    </ngx-charts-gauge>
    <!-- [valueFormatting]="labelFormatter.bind(this)" -->
</div>